"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the collection if the condition is true otherwise it will return an empty collection. Usually
 * used together with spread operators so you can easily make some items conditionally included or excluded
 *
 * @function insertItemsIf
 * @memberof Collection
 * @since 0.1.0
 *
 * @param {boolean} condition - determines if to return the items or just an empty collection
 * @param {Object<any> | any[]} items - collection to return
 * @returns {Object<any> | any[]} - returns array or an object whatever is the type of the items parameter
 * @example
 *
 * const fruits = ['apple', 'banana'];
 * const includeFruits = true;
 *
 * const allFoods = [
 *  'soup',
 *  'chicken',
 *  ...insertItemsIf(includeFruits, fruits)
 * ]
 * // => ['soup', 'chicken', 'apple', 'banana']
 */
var insertItemsIf = function insertItemsIf(condition, items) {
  var defaultValue = function () {
    if ((0, _isArray2.default)(items)) {
      return [];
    }

    if ((0, _isObject2.default)(items)) {
      return {};
    }

    return items;
  }();

  return condition ? items : defaultValue;
};

var _default = insertItemsIf;
exports.default = _default;